/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrderedFileDtoFromJSON, OrderedFileDtoToJSON, } from './';
export function CarPhotosDtoFromJSON(json) {
    return CarPhotosDtoFromJSONTyped(json, false);
}
export function CarPhotosDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mainPhoto': !exists(json, 'mainPhoto') ? undefined : OrderedFileDtoFromJSON(json['mainPhoto']),
        'photoFiles': !exists(json, 'photoFiles') ? undefined : (json['photoFiles'] === null ? null : json['photoFiles'].map(OrderedFileDtoFromJSON)),
        'modelFiles': !exists(json, 'modelFiles') ? undefined : (json['modelFiles'] === null ? null : json['modelFiles'].map(OrderedFileDtoFromJSON)),
    };
}
export function CarPhotosDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mainPhoto': OrderedFileDtoToJSON(value.mainPhoto),
        'photoFiles': value.photoFiles === undefined ? undefined : (value.photoFiles === null ? null : value.photoFiles.map(OrderedFileDtoToJSON)),
        'modelFiles': value.modelFiles === undefined ? undefined : (value.modelFiles === null ? null : value.modelFiles.map(OrderedFileDtoToJSON)),
    };
}
